module.exports = __webpack_public_path__ + "img/Robbi_Reset_button.5e5f7223.png";